<template>
	<del
		v-if="price"
		class="text-body-primary relative no-underline after:absolute after:border-t after:border-[#848484] after:inset-x-0 after:top-[0.65em]"
		:class="onlyLargePrice ? 'text-base' : 'text-xs sm:text-base'"
	>
		<span
			v-if="price"
			class=" [&_sup]:!text-[0.8em] [&_sup]:relative [&_sup]:top-[-0.15em] flex"
			v-html="formatPriceWithSuperscript(price)"
		/>
	</del>
</template>

<script setup lang="ts">
	import type {Gsoa_ProductCatalog_ProductInHouse as ProductInHouse} from '~/openapi';

	interface Props {
		price?: ProductInHouse['originalPrice'];
		onlyLargePrice?: boolean;
	}

	defineProps<Props>();
</script>
